// 身份证翻译相关API

// 上传身份证
export function uploadIdcard(filObj,side) {
    let params = new FormData();
    params.append("idcard", filObj);
    params.append("side", side);
    return{
        url: '/license_trans/idcard',
        method: 'post',
        data: params
    }
}


// 修改信息
export function idcardEditInfo(data) {
    return{
        url: '/license_trans/sure_idcard',
        method: 'post',
        data: data
    }
}


// 下载文件
export function downloadImg(id, type, side='') {
    return{
        url: `/license_trans/download/${id}?file_type=${type}&side=${side}`,
        method: 'get',
        responseType: 'blob'
    }
}
